import { render, staticRenderFns } from "./academicsDialog.vue?vue&type=template&id=53338842&scoped=true"
import script from "./academicsDialog.vue?vue&type=script&lang=js"
export * from "./academicsDialog.vue?vue&type=script&lang=js"
import style0 from "./academicsDialog.vue?vue&type=style&index=0&id=53338842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53338842",
  null
  
)

export default component.exports